


































































































import FlightRoute from "@/store/entities/flight/flightRoute";
import { Component, Vue } from "vue-property-decorator";
import AddFlightRoute from "./modals/addFlightRoute.vue";

@Component({
  components: { AddFlightRoute },
})
export default class FlightRoutes extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  flightRoutes: FlightRoute[] = [];

  created() {
    this.getFlightRoutes();
    (this.headers = [
      { text: "Kalkış", value: "departure" },
      { text: "Varış", value: "destination" },
      { text: "İşlemler", value: "transactions" },
    ]),
      // // this.mockData=[
      // //   {
      // //     departure: 'AYT',
      // //     destination: 'DME',
      // //   },

      // ]

      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Tanımlamalar", disabled: true },
        { text: "Uçuş Rotaları", disabled: true },
      ]);
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getFlightRoutes() {
    await this.$store.dispatch({
      type: "flightRoute/getFlightRoutes",
    });

    this.flightRoutes = this.$store.state.flightRoute.list;
  }

  editFlightRoute(item) {
    this.$store.state.flightRoute.editFlightRoute = item;
    this.isOpenModal = true;
  }

  async deleteFlightRoute(item) {
    await this.$store
      .dispatch({
        type: "flightRoute/deleteFlightRoute",
        payload: item.id,
      })
      .then((x) => {
        this.getFlightRoutes();
      });
  }

  confirmDelete(item) {
    this.$swal({
      title: "Satır Silinecetir.",
      text: "İşlemi Devam Ettirmeye Emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteFlightRoute(item);
        Vue.$toast.success("Silme Başarılı");
      }
    });
  }

  openModal() {
    this.$store.state.flightRoute.editFlightRoute = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getFlightRoutes();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
